//#region IMPORTS
import { fromBackendDate } from "../helpers/fromBackendDate";
import { InstoreTemplate } from "../models/instoreTemplate";
import { autoFitColumns } from "../helpers/autoFitColumns";
import { useState } from "react";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
//#endregion

export const useExportInstoreOrderTemplateToExcel = () => {
  const [exporting, setExporting] = useState(false);

  const exportTemplateToExcel = async (template: InstoreTemplate) => {
    setExporting(true);

    await toast.promise(
      Promise.resolve().then(() => {
        const rowsForExport = template.template_rows.map((row) => ({
          ArticleName: row.article_name,
          Amount: row.amount,
          Set: row.set,
          Price: row.price,
          GroupIndex: row.index,
          ThemaName: row.theme,
          TemplateName: template.name,
          OrderType: template.order_type_instore_name.toUpperCase(),
          StoreInstoreType: template.instore_type.toUpperCase(),
          StoreFormat: row.store_format,
          From: fromBackendDate(template.from),
          Until: fromBackendDate(template.until),
          Active: template.active ? "Yes" : "No",
        }));

        const worksheet = XLSX.utils.json_to_sheet(rowsForExport);
        autoFitColumns(worksheet, rowsForExport);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "sheet1");
        XLSX.writeFile(workbook, `${template.name}.xlsx`);
      }),
      {
        pending: "Preparing spreadsheet export.",
        success: "Spreadsheet exported successfully.",
        error: {
          render({ data }) {
            return data instanceof Error
              ? data.message
              : "Unexpected error while exporting Excel";
          },
        },
      }
    );

    setExporting(false);
  };
  return { exportTemplateToExcel, exporting };
};
